module.exports = __webpack_public_path__ + "img/terms-and-condition.e56c2b93.png";